import React from "react";
import moment from "moment";
import FileSaver from "file-saver";
const PaymentGridRow = ({ data, sno }: { data: any; sno: number }) => {
  const handleDownload = (fileName: string, filedata: string) => {
    try {
      const byteCharacters = atob(filedata);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      FileSaver.saveAs(blob, fileName);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  return (
    <tr>
      <td>{sno || ""}</td>
      <td>{data?.referenceNumber || ""}</td>
      <td>{data?.transactionNumber || ""}</td>
      <td>{data?.paymentAmount?.toFixed(2) || ""}</td>
      <td>{moment(data?.paymentDate).format("DD/MM/yyyy")}</td>
      <td>{data?.paymentType || ""}</td>
      <td>{data?.paymentstatusText || ""}</td>
      <td>
        {data?.filedata && (
          <button
            type="button"
            className="amendment"
            onClick={() => handleDownload(data?.fileName, data.filedata)}
          >
            Download
          </button>
        )}
      </td>
    </tr>
  );
};

export default PaymentGridRow;
